import React from 'react';
import { Route, Switch } from 'react-router-dom';

import asyncComponent from '../components/AsyncComponent';
import AuthenticatedRoute from '../components/AuthenticatedRoute';
import UnauthenticatedRoute from '../components/UnauthenticatedRoute';
import { ROLES } from '../libs/Constants';
import RoleCheck from '../libs/RoleCheck';
import { PATHS } from './routes.constants';

const AsyncLogin = asyncComponent(() =>
  import('../containers/Login/indexDragonfly')
);
const AsyncSSO = asyncComponent(() => import('../containers/SSO'));
const AsyncProfile = asyncComponent(() => import('../containers/Profile'));
const AsyncDashboard = asyncComponent(() => import('../containers/Dashboard'));
const AsyncReporting = asyncComponent(() => import('../containers/Reporting'));
const AsyncNotFound = asyncComponent(() => import('../components/NotFound'));
const AsyncUsers = asyncComponent(() => import('../containers/Admin'));
const AsyncNewPassword = asyncComponent(() =>
  import('../containers/NewPassword')
);
const AsyncReviews = asyncComponent(() => import('../containers/Reviews'));
const AsyncTeam = asyncComponent(() => import('../containers/Team'));
const AsyncUser = asyncComponent(() => import('../containers/User'));
const AsyncFeature = asyncComponent(() => import('../containers/Feature'));
const AsyncSearch = asyncComponent(() => import('../containers/Search'));
const AsyncEntityRule = asyncComponent(() =>
  import('../containers/EntityRule')
);
const AsyncEntityContacts = asyncComponent(() =>
  import('../containers/EntityContacts')
);
const AsyncCMS = asyncComponent(() => import('../containers/CMS'));
const AsyncChart = asyncComponent(() => import('../containers/Chart'));
const AsyncChartRR = asyncComponent(() =>
  import('../containers/Chart/indexRR')
);
const AsyncViewAndDo = asyncComponent(() => import('../containers/ViewAndDo'));
const AsyncRecentlyViwedPatients = asyncComponent(() =>
  import('../containers/RecentlyViewedQueue')
);
const AsyncMessageCenter = asyncComponent(() =>
  import('../containers/MessageCenter')
);
const PatientWorkQueue = asyncComponent(() =>
  import('../features/PatientWorkQueue/PatientWorkQueue.connected')
);
const CustomPopulation = asyncComponent(() =>
  import('../features/CustomPopulation/CustomPopulation.connected')
);

const Routes = ({ childProps }) => {
  return (
    <Switch>
      <AuthenticatedRoute
        component={PatientWorkQueue}
        exact
        path={PATHS.HOME}
        props={childProps}
      />
      <UnauthenticatedRoute
        component={AsyncLogin}
        exact
        path={PATHS.LOGIN}
        props={childProps}
      />
      <UnauthenticatedRoute
        component={AsyncSSO}
        exact
        path={PATHS.SSO}
        props={childProps}
      />
      <UnauthenticatedRoute
        component={AsyncNewPassword}
        exact
        path={PATHS.NEW_PASSWORD}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncProfile}
        exact
        path={PATHS.PROFILE}
        props={childProps}
      />
      <AuthenticatedRoute
        component={PatientWorkQueue}
        exact
        path={PATHS.QUEUE}
        props={childProps}
      />
      <AuthenticatedRoute
        component={PatientWorkQueue}
        exact
        path={PATHS.TEAMS_QUEUE}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncDashboard}
        exact
        path={PATHS.DASHBOARD}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncRecentlyViwedPatients}
        exact
        path={PATHS.RECENTLY_VIEWED_PATIENTS}
        props={childProps}
      />

      {RoleCheck(childProps.userRoles, [
        ROLES.SYSTEM_ADMINISTRATOR,
        ROLES.ADMINISTRATOR,
        ROLES.TEAM_LEAD,
        ROLES.SUPPORT,
      ]) && (
        <AuthenticatedRoute
          component={AsyncReporting}
          exact
          path={PATHS.REPORTING}
          props={childProps}
        />
      )}

      {RoleCheck(childProps.userRoles, [
        ROLES.SYSTEM_ADMINISTRATOR,
        ROLES.ADMINISTRATOR,
      ]) && (
        <AuthenticatedRoute
          component={AsyncUsers}
          exact
          path={PATHS.ADMIN}
          props={childProps}
        />
      )}

      {RoleCheck(childProps.userRoles, [
        ROLES.SYSTEM_ADMINISTRATOR,
        ROLES.ADMINISTRATOR,
      ]) && (
        <AuthenticatedRoute
          component={AsyncEntityRule}
          exact
          path={PATHS.ENTITY_RULES}
          props={childProps}
        />
      )}

      {RoleCheck(childProps.userRoles, [
        ROLES.SYSTEM_ADMINISTRATOR,
        ROLES.ADMINISTRATOR,
      ]) && (
        <AuthenticatedRoute
          component={AsyncEntityContacts}
          exact
          path={PATHS.ENTITY_CONTACTS}
          props={childProps}
        />
      )}

      <AuthenticatedRoute
        component={AsyncReviews}
        path={PATHS.ADMISSION_REVIEWS}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncViewAndDo}
        path={PATHS.ADMISSION_RR_REVIEWS}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncTeam}
        exact
        path={PATHS.TEAM}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncUser}
        exact
        path={PATHS.USER}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncUser}
        exact
        path={PATHS.USER_NAME}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncFeature}
        exact
        path={PATHS.FEATURES}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncFeature}
        exact
        path={PATHS.FEATURE}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncSearch}
        exact
        path={PATHS.SEARCH}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncCMS}
        exact
        path={PATHS.CMS}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncChart}
        path={PATHS.ENTITY_CHART}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncChartRR}
        path={PATHS.RR_ENTITY_CHART}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncChart}
        path={PATHS.REVIEW}
        props={{ ...childProps, isReview: true }}
      />
      <AuthenticatedRoute
        component={AsyncViewAndDo}
        path={PATHS.RR_REVIEW}
        props={{ ...childProps, isReview: true }}
      />
      <AuthenticatedRoute
        component={AsyncViewAndDo}
        path={PATHS.VIEW_AND_DO}
        props={childProps}
      />
      <AuthenticatedRoute
        component={AsyncMessageCenter}
        path={PATHS.MESSAGE_CENTER}
        props={childProps}
      />
      <AuthenticatedRoute
        component={CustomPopulation}
        exact
        path={PATHS.CUSTOM_POPULATION}
        props={childProps}
      />
      {/* Finally, catch all unmatched routes */}
      <Route component={AsyncNotFound} />
    </Switch>
  );
};

export default Routes;
